import axios from 'axios';

import storeHelpers from '@/store/helpers';

class AxiosBase {
  constructor(baseURL = '', withToken = false) {
    const config = { timeout: 30000, baseURL };

    if (withToken) {
      const token = storeHelpers.getFromLocal('token');
      config.headers = { Authorization: `Bearer ${token}` };
    }

    return axios.create(config);
  }
}

export default AxiosBase;
